import { Typography } from '@mui/material';
import { t } from 'i18next';
import { RedWarningIcon } from '../../assets/images';
import { MuiButton } from '../atoms/buttonComponent';
import { MuiStack } from '../atoms/stackComponent';
import { MuiPopup } from './popupComponent';
function UnsavedChangesPopup(props) {
    var isOpen = props.isOpen, onClosePopup = props.onClosePopup, onClickNoBtn = props.onClickNoBtn, onClickYesBtn = props.onClickYesBtn;
    return /*#__PURE__*/ React.createElement(MuiPopup, {
        variant: "h1",
        openPopup: isOpen,
        closeIcon: true
        // backdropEnable={true}
        ,
        onClose: function () {
            onClosePopup(false);
        },
        padding: "16px 0px 0px 16px",
        headerIcon: RedWarningIcon
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        id: 'unsaved-changes',
        flexDirection: "column",
        padding: 0,
        margin: 0
    }, /*#__PURE__*/ React.createElement(Typography, {
        fontSize: "xxl",
        fontWeight: "strong"
    }, t("Unsaved changes")), /*#__PURE__*/ React.createElement(Typography, {
        variant: "h4",
        color: "textSecondary",
        marginTop: 2
    }, t("Are you sure you want to leave this page without saving your changes? Any unsaved data will be lost.")), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: {
            xs: 'column',
            sm: 'row-reverse'
        },
        spacing: 3,
        marginTop: 4,
        paddingTop: 2,
        minWidth: '100%'
    }, /*#__PURE__*/ React.createElement(MuiButton, {
        id: "yes-btn",
        size: "medium",
        fullWidth: true,
        name: t("Leave this page"),
        variant: "contained"
        // style={{ background: '#F5222D' }}
        ,
        color: "error",
        onClick: onClickNoBtn
    }), /*#__PURE__*/ React.createElement(MuiButton, {
        id: "no-btn",
        size: "medium",
        fullWidth: true,
        name: t("Stay on this page"),
        variant: "outlined",
        color: "secondary"
        // style={{ border: '1px solid #DEE4EB', color: '#6A7682' }}
        ,
        onClick: onClickYesBtn
    }))));
}
export default UnsavedChangesPopup;
